

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export function Logo({ className = '', size = 'md', showText = true }: LogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <img
        src="/ima_onboard_logo.png"
        alt="Ideal Mobile App Logo"
        className={`${sizeClasses[size]} object-contain`}
      />
      {showText && (
        <div className="flex flex-col">
          <span className="font-bold text-gray-900">Ideal Mobile App</span>
          <span className="text-sm text-gray-600">Onboarding Portal</span>
        </div>
      )}
    </div>
  );
}
